import axios from "axios"
import { GET_COMPONENT } from "../utils/endpoints/ComponentEndpoints"


export const getComponent = (idType: any, idBrand: any) => {
    return axios.get(GET_COMPONENT(idType, idBrand));
}